// @flow

import React from "react";

import { Header, HeaderContainer, HeaderLogo } from "./components";

export default class extends React.Component {
  render() {
    return (
      <Header>
        <div className="container">
          <HeaderContainer>
            <HeaderLogo>
              <img
                src={
                  this.props.logo
                    ? this.props.logo
                    : require("./../../../public/assets/images/PSHSA_Logo.svg")
                }
                alt="logo"
              />
            </HeaderLogo>
          </HeaderContainer>
        </div>
      </Header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/index.jsx